// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"249":"357d00c9","310":"27aacea7","496":"dc479ee2"}[chunkId] + ".css";
};